<template>
  <div class="side_tab_box summary_box" :class="sidebarTabClass">
    <div class="side_tab_box_inner">
      <a
        class="close close_summary"
        title="Zavřít"
        @click="onCloseClick"
      >Zavřít</a>
      <template v-if="pending">
        <h2 v-translate>Přehled o zpracování TV programu</h2>
      </template>

      <template v-else>
        <h2 v-translate>Přehled o zpracování TV programu</h2>

        <div class="summary_row">
          <section-title :title="translations.archive" :days="broadcastOverview.settings.archiveDuration" />
          <days
            :date-from="archiveGroup.fromTimestamp"
            :date-to="archiveGroup.toTimestamp"
          />
          <progress-bar title="EPG PLUS" :fractions="getFractions(archiveGroup, 'TV_STATION_EPG_PLUS')" />
          <progress-bar title="EPG REST" :fractions="getFractions(archiveGroup, 'TV_STATION_EPG_REST')" />
        </div>

        <div class="summary_row">
          <section-title :title="translations.processing" :days="epgProcessingEndDays" />
          <days
            :date-from="processingGroup.fromTimestamp"
            :date-to="processingGroup.toTimestamp"
          />
          <progress-bar title="EPG PLUS" :fractions="getFractions(processingGroup, 'TV_STATION_EPG_PLUS')" />
          <progress-bar title="EPG REST" :fractions="getFractions(processingGroup, 'TV_STATION_EPG_REST')" />
        </div>

        <div class="summary_row">
          <section-title :title="translations.imported" :days="broadcastOverview.settings.importDuration" />
          <days
            :date-from="importedGroup.fromTimestamp"
            :date-to="importedGroup.toTimestamp"
          />
          <progress-bar title="EPG PLUS" :fractions="getFractions(importedGroup, 'TV_STATION_EPG_PLUS')" />
          <progress-bar title="EPG REST" :fractions="getFractions(importedGroup, 'TV_STATION_EPG_REST')" />
        </div>

        <description />

        <p class="summary_all">
          <span v-translate>Počet vysílání:</span> {{ broadcastOverview.numberOfBroadcasts }}
        </p>
        <p class="summary_all">
          <span v-translate>Počet pořadů:</span> {{ broadcastOverview.numberOfShows }}
        </p>
      </template>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import { LAYOUT_ITEM_OVERVIEW, LAYOUT_SET_SIDEBAR_TAB_OPEN } from 'store/modules/layout'
import ProgressBar from './ProgressBar'
import Days from './Days'
import SectionTitle from './SectionTitle'
import Description from './Description'

export default {
  name: 'overview',
  components: {
    Description,
    ProgressBar,
    Days,
    SectionTitle
  },
  computed: {
    ...mapState({
      activeSidebarTab: state => state.layout.activeSidebarTab,
      broadcastOverview: state => state.broadcasts.broadcastOverview,
      pending: state => state.broadcasts.pending.broadcastOverview
    }),
    translations() {
      return {
        archive: this.$gettext('Archiv'),
        processing: this.$gettext('Zpracovává se'),
        imported: this.$gettext('Importováno'),
      }
    },
    sidebarTabClass() {
      return {
        'active': this.activeSidebarTab === LAYOUT_ITEM_OVERVIEW
      }
    },
    archiveGroup() {
      return this.broadcastOverview && this.broadcastOverview.groups.find(v => v.groupType === 'archive')
    },
    processingGroup() {
      return this.broadcastOverview && this.broadcastOverview.groups.find(v => v.groupType === 'processing')
    },
    importedGroup() {
      return this.broadcastOverview && this.broadcastOverview.groups.find(v => v.groupType === 'imported')
    },
    epgProcessingEndDays() {
      const fromDate = moment.unix(this.processingGroup.fromTimestamp).utc()
      const toDate = moment.unix(this.processingGroup.toTimestamp).utc()

      return toDate.diff(fromDate, 'days') + 1
    }
  },
  methods: {
    ...mapActions(['getBroadcastOverview']),
    onCloseClick() {
      this.$store.commit({
        type: LAYOUT_SET_SIDEBAR_TAB_OPEN,
        name: ''
      })
    },
    getFractions(group, type) {
      const unit = group.units.find(v => v.tvStationType === type)
      return unit ? unit.fractions : []
    }
  },
  watch: {
    activeSidebarTab(value) {
      if (value === LAYOUT_ITEM_OVERVIEW) {
        this.getBroadcastOverview()
      }
    }
  }
}
</script>
